import React, {useMemo} from 'react'
import { useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import {Button, Space} from 'antd'

import {CreateBankAccountStep} from '@/stores/bank-account-create/models'

import {FormActionsButtonProps} from './props'
import {
    CANCEL_VERIFICATION,
    CLOSE_CREATE,
    CONTACT_SUPPORT,
    PROCEED_TO_OUTLETS,
    START_VERIFICATION
} from '@/constants/playwright-ids'

export const FormActionButtons = observer(
    ({
        step,
        onBack,
        openChat,
        isValidationPassed,
        onSuccessAction,
        startVerificationTag,
        proceedToOutletsTag,
        contactSupportTag,
        initialFormCancelTag,
        successCancelTag,
        failureCancelTag
    }: FormActionsButtonProps) => {
        const { t } = useTranslation()

        const buttons = useMemo(
            () => ({
                [CreateBankAccountStep.initialForm]: (
                    <Space>
                        <Button
                            className={startVerificationTag}
                            type='primary'
                            htmlType='submit'
                            disabled={!isValidationPassed}
                            data-test-id={START_VERIFICATION}
                        >
                            <span className={startVerificationTag}>{t('BankAccountCreate.buttons.startVerification')}</span>
                        </Button>
                        <Button
                            className={initialFormCancelTag}
                            onClick={onBack}
                            data-test-id={CANCEL_VERIFICATION}
                        >
                            <span className={initialFormCancelTag}>{t('BankAccountCreate.buttons.cancel')}</span>
                        </Button>
                    </Space>
                ),
                [CreateBankAccountStep.success]: (
                    <Space>
                        <Button
                            className={proceedToOutletsTag}
                            type='primary'
                            htmlType={'button'}
                            onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                onSuccessAction()
                            }}
                            data-test-id={PROCEED_TO_OUTLETS}
                        >
                            <span className={proceedToOutletsTag}>{t('BankAccountCreate.buttons.proceedToOutlets')}</span>
                        </Button>
                        <Button
                            htmlType={'button'}
                            className={successCancelTag}
                            onClick={onBack}
                            data-test-id={CLOSE_CREATE}
                        >
                            <span className={successCancelTag}>{t('BankAccountCreate.buttons.close')}</span>
                        </Button>
                    </Space>
                ),
                [CreateBankAccountStep.failure]: (
                    <Space>
                        <Button
                            htmlType={'button'}
                            className={contactSupportTag}
                            type='primary'
                            onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                openChat()
                            }}
                            data-test-id={CONTACT_SUPPORT}
                        >
                            <span className={contactSupportTag}>{t('BankAccountCreate.buttons.contactSupport')}</span>
                        </Button>
                        <Button className={failureCancelTag} onClick={onBack}>
                            <span className={failureCancelTag}>{t('BankAccountCreate.buttons.cancel')}</span>
                        </Button>
                    </Space>
                )
            }),
            [t, isValidationPassed, onBack, openChat, onSuccessAction]
        )

        return (
            <div>
                <br />
                <br />
                {buttons[step] || null}
            </div>
        )
    }
)
